<script>
  import { onMount, onDestroy } from "svelte";
  import { get } from "svelte/store";
  import clsx from "clsx";
  import { validator } from "svelte-formly/src/Validation";
  import { valuesForm } from "svelte-formly/src/Components/stores.js";
  import { trovaCoords, url } from "./trovaURL";
  // Import components.
  import Tag from "svelte-formly/src/Components/Tag.svelte";
  import Input from "./Input.svelte";
  import Textarea from "svelte-formly/src/Components/Textarea.svelte";
  import Select from "svelte-formly/src/Components/Select.svelte";
  import AutoComplete from "svelte-formly/src/Components/AutoComplete.svelte";
  import Radio from "svelte-formly/src/Components/Radio.svelte";
  import Checkbox from "svelte-formly/src/Components/Checkbox.svelte";
  import File from "svelte-formly/src/Components/File.svelte";
  import Message from "svelte-formly/src/Components/Message.svelte";

  // Declar variables;
  export let fields = [];
  let values = [];
  let isValidForm = true;
  let placeholder;
  let currentLanguage = navigator.language.substring(0, 2);

  var myCookie = sessionStorage.getItem("key");

  if (myCookie == "" || myCookie == null || !myCookie)
    myCookie = currentLanguage;

  function TrovaLingua() {
    myCookie = sessionStorage.setItem(
      "key",
      document.getElementById("lingua").value
    );
    location.reload();
  }
  switch (myCookie) {
    case "de":
      placeholder = "Breite , Länge";
      break;
    case "fr":
      placeholder = "Latitude , Longitude";
      break;
    case "es":
      placeholder = "Latitud , longitud";
      break;
    case "it":
      placeholder = "Latitudine , Longitudine";
      break;
    case "en":
      placeholder = "Latitude , Longitude";
      break;
    default:
      placeholder = "Latitude , Longitude";
  }
  // Set values form and status validation.
  const setValuesForm = (isValidForm, values) => {
    valuesForm.set({
      isValidForm,
      values: { ...values }
    });
  };
  // Change values.
  const changeValueHander = event => {
    values[`${event.detail.name}`] = event.detail.value;
    fields.filter(field => {
      if (field.name === event.detail.name) {
        field.value = event.detail.value;
      }
    });
    setValuesForm(isValidForm, values);
  };
  // Validation Form.
  let fieldsToValidate = {};
  const form = validator(() => {
    if (fields.length > 0) {
      fields.map(field => {
        let { validation } = field;
        const value = field.value ? field.value : null;
        const fieldValidate = {
          [field.name]: {
            value: values[field.name] ? values[field.name] : value,
            validators: validation,
            file: field.type === "file" ? field.file : null
          }
        };
        fieldsToValidate = { ...fieldsToValidate, ...fieldValidate };
      });
    }
    return fieldsToValidate;
  });
  form.subscribe(data => {
    isValidForm = data.valid;
    setValuesForm(isValidForm, values);
  });
  // Lifecycle mount to start.
  onMount(() => {
    $valuesForm;
  });
  // Lifecycle destroy to unbscribe.
  // onDestroy([valuesForm]);

  function ifRequired(field) {
    if (field.required == true) return "required";
    else return "";
  }
</script>

{#each fields as field (field.name)}

  <!-- Prefix -->
  <Tag
    tag={field.prefix ? (field.prefix.tag ? field.prefix.tag : 'div') : 'div'}
    classes={field.prefix ? (field.prefix.class ? field.prefix.class : 'form-group') : 'form-group'}>
    <!-- Label -->
    {#if field.label}
      <label for={field.id} class="titolo">{field.label}</label>
    {/if}
    <!-- Field -->

    <!-- {#if field.id === 'company_name' || field.name === 'website' || field.name === 'address' || field.name === 'post_code' || field.name === 'location_city' || field.name === 'province_region_state' || field.name === 'country' || field.name === 'telephone'}
        <Input
          type={field.type}
          id={field.id}
          name={field.name}
          value={field.value}
          classe={field.class}
          placeholder={field.placeholder}
          min={field.min}
          max={field.max}
          step={field.step}
          autocomplete={field.autocomplete}
          disabled={field.disabled}
          readonly={field.readonly}
          required="ifRequired(field.required)"
          title={field.note}
          on:changeValue={changeValueHander} />
        {#if field.note}
          <small class="form-text text-muted">{field.note}</small>
        {/if} -->
    {#if field.type === 'text' || field.type === 'password' || field.type === 'tel' || field.type === 'number' || field.type === 'range' || field.type === 'date' || field.type === 'color' || field.type === 'datetimelocal'}
      <Input
        type={field.type}
        id={field.id}
        name={field.name}
        value={field.value}
        classe={field.class}
        placeholder={field.placeholder}
        min={field.min}
        max={field.max}
        step={field.step}
        autocomplete={field.autocomplete}
        disabled={field.disabled}
        readonly={field.readonly}
        title={field.note}
        on:changeValue={changeValueHander} />
      {#if field.note}
        <small class="form-text text-muted">{field.note}</small>
      {/if}
    {:else if field.type === 'textarea'}
      <Textarea
        id={field.id}
        name={field.name}
        value={field.value}
        classe={field.class}
        rows={field.rows}
        cols={field.cols}
        disabled={field.disabled}
        readonly={field.readonly}
        on:changeValue={changeValueHander} />
    {:else if field.type === 'email'}
      <Input
        type="email"
        id={field.id}
        name={field.name}
        value={field.value}
        classe={field.class}
        placeholder="example@mail.com"
        min={field.min}
        max={field.max}
        step={field.step}
        autocomplete={field.autocomplete}
        disabled={field.disabled}
        readonly={field.readonly}
        title={field.note}
        required="ifRequired(field.required)"
        on:changeValue={changeValueHander} />
    {:else if field.type === 'select'}
      <Select
        id={field.id}
        name={field.name}
        classe={field.class}
        options={field.options}
        disabled={field.disabled}
        multiple={field.multiple}
        on:changeValue={changeValueHander} />
      {#if field.note}
        <small class="form-text text-muted">{field.note}</small>
      {/if}
    {:else if field.type === 'autocomplete'}
      <AutoComplete
        id={field.id}
        name={field.name}
        classe={field.class}
        loadItemes={field.loadItemes}
        disabled={field.disabled}
        multiple={field.multiple}
        on:changeValue={changeValueHander}
        on:onSelectItem />
    {:else if field.type === 'radio'}
      <Radio
        name={field.name}
        classe={field.class}
        items={field.items}
        aligne={field.aligne}
        on:changeValue={changeValueHander} />
    {:else if field.type === 'checkbox'}
      <Checkbox
        classe={field.class}
        items={field.items}
        aligne={field.aligne}
        on:changeValue={changeValueHander} />
    {:else if field.type === 'file'}
      <File
        id={field.id}
        name={field.name}
        classe={field.class}
        disabled={field.disabled}
        multiple={field.multiple}
        showPreview={field.showPreview}
        on:changeValue={changeValueHander} />
    {:else if field.type === 'datetimelocal'}
      <File
        id={field.id}
        name={field.name}
        classe={field.class}
        disabled={field.disabled}
        multiple={field.multiple}
        showPreview={field.showPreview}
        on:changeValue={changeValueHander} />
    {:else if field.type === 'geo'}
      <div class="geo">
        <Input
          type={field.type}
          id={field.id}
          name={field.name}
          value={field.value}
          classe={field.class}
          {placeholder}
          min={field.min}
          max={field.max}
          step={field.step}
          autocomplete={field.autocomplete}
          disabled={field.disabled}
          readonly={field.readonly}
          on:changeValue={changeValueHander} />

        <button
          class="button1 btn btn-outline-primary trovaCoords"
          type="button"
          value="Trova Coordinate"
          on:click={trovaCoords}>
          📌
        </button>

      </div>
      {#if field.note}
        <small class="form-text text-muted">{@html field.note}</small>
      {/if}
      <!-- {#if field.note}
        <small class="form-text text-muted">{field.note}</small>
      {/if} -->
    {/if}

    <!-- Description -->
    {#if field.description}
      {#if field.description.text}
        <Tag tag={field.description.tag} classes={field.description.class}>
          {field.description.text}
        </Tag>
      {/if}
    {/if}
    <!-- Error messages -->
    {#if !isValidForm}
      {#if $form[field.name].validation.errors.length > 0}
        {#each $form[field.name].validation.errors as error, index}
          <Message {error} messages={field.messages} />
        {/each}
      {/if}
    {/if}
  </Tag>
{/each}
